/*
  This component just takes care of rendering the content of the route.
  The logic for determining the route is handled by the Routes component.
 */
export default function Route({ children }) {
	return children;
}
